import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '../../../components/common/Button';
import { close } from '../../../modules/modal/actions';
import { SAVED_SLIPS } from '../../../routes/paths';

export const SavedSlipsLimitReached = ({ closeModal, history }) => {
  const clickViewSavedSlips = () => {
    history.push(SAVED_SLIPS);
    closeModal();
  };

  return (
    <div className="modal saved-slips-limit-reached">
      <div className="saved-slips-limit-reached__header">Maximum number of slips already saved!
      </div>
      <p className="saved-slips-limit-reached__paragraph">
        Delete any unwated saved slips before saving another.
      </p>
      <div className="modal__responsive-buttons">
        <Button
          className="modal__button"
          onClick={clickViewSavedSlips}
        >
          View Saved Slips
        </Button>
        <Button
          className="modal__button button--secondary"
          onClick={closeModal}
        >
          Close
        </Button>
      </div>
    </div>
  );
};

SavedSlipsLimitReached.propTypes = {
  closeModal: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

const mapDispatchToProps = {
  closeModal: close
};

export default withRouter(connect(null, mapDispatchToProps)(SavedSlipsLimitReached));
